var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ym-playing-btn',{staticClass:"header-playing-btn",attrs:{"show":_vm.show,"status":_vm.floatBtnStatus},on:{"click":_vm.handleClickFloatBtn}})}
var staticRenderFns = []

export { render, staticRenderFns }